import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import { EarnSheetProvider, useEarnSheetContext } from './context/EarnSheetProvider'
import { useEarnModel } from './hooks/useEarnModel'
import { useEarnTracking } from './hooks/useEarnTracking'
import { EARN_MODEL, EARN_SHEET_ACTION_TYPE, EarnDetailsAsset } from './types'
import { EarnDirectDetailsView } from './views/direct/EarnDirectDetailsView'
import { EarnEmbeddedDetailsView } from './views/embedded/EarnEmbeddedDetailsView'

export const EarnDetails = () => (
  <EarnSheetProvider>
    <EarnDetailsContent />
  </EarnSheetProvider>
)

const EarnDetailsContent = () => {
  const { t } = useTranslation()
  const { portfolioId } = useParams<{ portfolioId: string }>()
  const { handleSheetOpen } = useEarnSheetContext()
  const { trackPageView } = useEarnTracking()
  const earnModel = useEarnModel()

  const handleDeposit = (asset: EarnDetailsAsset) => {
    handleSheetOpen({
      type: EARN_SHEET_ACTION_TYPE.DEPOSIT,
      header: t('earn.depositSheet.header'),
      selectedCurrency: asset.asset,
      portfolioId: asset.portfolioId,
      productName: asset.productName,
    })
  }

  const handleWithdraw = (asset: EarnDetailsAsset) => {
    handleSheetOpen({
      type: EARN_SHEET_ACTION_TYPE.WITHDRAW,
      header: t('earn.withdrawSheet.header'),
      selectedCurrency: asset.asset,
      portfolioId: asset.portfolioId,
      productName: asset.productName,
    })
  }

  useEffect(() => {
    trackPageView('details', { portfolioId })
  }, [trackPageView, portfolioId])

  if (earnModel === EARN_MODEL.DIRECT) {
    return (
      <EarnDirectDetailsView
        portfolioId={portfolioId}
        onDeposit={handleDeposit}
        onWithdraw={handleWithdraw}
      />
    )
  }

  return (
    <EarnEmbeddedDetailsView
      portfolioId={portfolioId}
      onDeposit={handleDeposit}
      onWithdraw={handleWithdraw}
    />
  )
}
